import { logger } from "../../utils/logger";
import { postGripperControl } from "./gripperControl";
import type { PickPlaceStage } from "./pickPlaceServoConfig";

export type GripperCommandState = {
  key: string | null;
  value: number | null;
  mode: "open" | "close" | null;
};

export type GripperCommandTracker = ReturnType<typeof createGripperCommandTracker>;

export function createGripperCommandTracker(args: {
  physicsWorker: Worker;
  isDebugEnabled: () => boolean;
  getStage: () => PickPlaceStage;
}) {
  let lastCommand: GripperCommandState = {
    key: null,
    value: null,
    mode: null,
  };
  let lastLoggedMode: "open" | "close" | null = null;
  let initialOpenSent = false;

  const command = (mode: "open" | "close") => {
    const result = postGripperControl(mode, args.physicsWorker);
    if (!result.ok) return false;
    lastCommand = { key: result.key, value: result.value, mode };
    if (args.isDebugEnabled() && lastLoggedMode !== mode) {
      lastLoggedMode = mode;
      logger.info("[ik-pickplace] GRIPPER_CMD", {
        stage: args.getStage(),
        mode,
        key: result.key,
        value: result.value,
      });
    }
    return true;
  };

  return {
    maybeOpenOnce() {
      if (initialOpenSent) return;
      initialOpenSent = true;
      postGripperControl("open", args.physicsWorker);
    },
    close() {
      return command("close");
    },
    open() {
      return command("open");
    },
    getLastCommand() {
      return lastCommand;
    },
  };
}
